import React from 'react';
import './EmergencyContacts.css';

const EmergencyContacts = () => {
  const contacts = [
    {
      title: 'Police Emergency',
      phone: '112',
      description: 'For reporting crimes, disturbances, or emergencies requiring police intervention.'
    },
    {
      title: 'Fire Service',
      phone: '0803-456-7890',
      description: 'In case of fire outbreaks or related emergencies.'
    },
    {
      title: 'Medical Emergency',
      phone: '0806-123-4567',
      description: 'For health emergencies, ambulance requests, or immediate medical attention.'
    },
    {
      title: 'Disaster Response Unit',
      phone: '0705-987-6543',
      description: 'Handles natural disasters, evacuation, and emergency logistics.'
    }
  ];

  return (
    <section className="emergency-contacts">
      <div className="emergency-contacts-wrapper">
        <h2 className="emergency-contacts-section-title">Emergency Contacts</h2>
        <div className="emergency-contacts-grid">
          {contacts.map((contact, index) => (
            <div className="emergency-contacts-card" key={index}>
              <h3>{contact.title}</h3>
              <p className="emergency-contacts-phone">📞 {contact.phone}</p>
              <p>{contact.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EmergencyContacts;